import { useState, useContext, useEffect } from 'react';
import MercuryContext from 'ConnectionManager/mercuryContext';
import { queryGetScoresByActivity, queryGetScoresByInteractive } from './childGradesQueries';
import { ACTIVITY } from '../../constants';

/**
 * Loads the grade data for a list of activities and / or interactives.
 * @param {string} cohortId The cohort id
 * @param {string} deploymentId The deployment id
 * @param {string} parentActivityId The common parent activity of the given children
 * @param {Walkable[]} childWalkables An array of walkables.
 * @returns {{ errors: Object[], data: Object }}
 * An apollo state object containing list of errors, and the fetched data (A map of walkableIds
 * to grade values).
 */
export default function useChildLearnerGrades(cohortId, deploymentId, parentActivityId, childWalkables) {
  const { apolloClient } = useContext(MercuryContext);
  const [errors, setErrors] = useState(null);
  const [data, setData] = useState({});

  useEffect(() => {
    // Clear errors, but persist data
    setErrors(null);

    if (!childWalkables) {
      return;
    }

    childWalkables.forEach(({ id: childId, elementType }) => {
      const promise = elementType === ACTIVITY
        ? (
          queryGetScoresByActivity(apolloClient, {
            cohortId,
            deploymentId,
            activityId: childId,
          })
        ) : (
          queryGetScoresByInteractive(apolloClient, {
            cohortId,
            deploymentId,
            interactiveId: childId,
            activityId: parentActivityId,
          })
        );

      promise
        .then((result) => setData((prevState) => ({ ...prevState, [childId]: result })))
        .catch((error) => setErrors((prevState = []) => [...prevState, error]));
    });
  }, [apolloClient, cohortId, deploymentId, parentActivityId, childWalkables]);

  return { errors, data };
}
